(() => {
  const root = window.Shopify?.routes?.root || '/';
  const words = window.aidStrings || {};
  const money = cents => new Intl.NumberFormat('en-IN', {style:'currency',currency:'INR'}).format(cents / 100);
  const getCart = async () => { const r = await fetch(`${root}cart.js`, {cache:'no-store'}); if (!r.ok) throw Error(words.save_error); return r.json(); };
  const isWork = item => /work\s*suit/i.test(item.product_type || item.type || '');
  const step = item => { const label = `${item.product_title || item.title || ''} ${(item.tags || []).join(' ')}`; return Number(label.match(/(\d+)\s*pcs\s*set/i)?.[1]) || 1; };
  const normalizePhone = value => {
    let number=String(value || '').trim().replace(/[\s().-]/g,'');
    if(number.startsWith('00'))number='+'+number.slice(2);
    if(/^[6-9][0-9]{9}$/.test(number))number='+91'+number;
    else if(/^[1-9][0-9]{10,14}$/.test(number))number='+'+number;
    return /^\+[1-9][0-9]{7,14}$/.test(number) && (!number.startsWith('+91') || /^\+91[6-9][0-9]{9}$/.test(number)) ? number : '';
  };
  window.aidNormalizePhone=normalizePhone;
  const enquiryURL = (cart, attributes) => {
    const lines=['Al Imran Dresses — Order enquiry'];
    for(const item of cart.items || []) {
      lines.push(`${item.product_title || item.title} — ${item.variant_title || ''} — Qty: ${item.quantity} — ${money(item.final_line_price ?? item.line_price)}`);
      for(const [key,value] of Object.entries(item.properties || {})) if(value && !key.startsWith('_')) lines.push(`${key}: ${value}`);
      if(item.url) lines.push(new URL(item.url,window.location.origin).href);
    }
    lines.push(`Product estimate: ${money(cart.total_price)}`);
    for(const [key,value] of Object.entries(attributes)) if(value) lines.push(`${key}: ${value}`);
    if(cart.note) lines.push(`Note: ${cart.note}`);
    lines.push('Please confirm stock, shipping method, shipping charges and payment details on WhatsApp. This is an enquiry, not a confirmed order.');
    return `https://wa.me/919821143696?text=${encodeURIComponent(lines.join('\n'))}`;
  };
  window.aidEnquiryURL=enquiryURL;

  const calculate = cart => {
    const weights = {4:2.5,6:3.5,8:4,10:5};
    const kg = (cart.items || []).reduce((n,item) => n + item.quantity * ((weights[step(item)] || step(item) * .6) / step(item)), 0);
    const billedKg = Math.ceil(Number(kg.toFixed(3)));
    return {kg,billedKg,charge:0,total:cart.total_price};
  };
  window.aidValidateCart = cart => {
    const totals = new Map();
    for (const item of cart.items || []) {
      if (isWork(item)) totals.set(item.product_id,(totals.get(item.product_id)||0)+item.quantity);
      else if (item.quantity % step(item)) throw Error(words.set_error);
    }
    if ([...totals.values()].some(n=>n>4)) throw Error(words.work_limit);
  };
  window.aidEstimate = {calculate, step};
  function bindEstimate(container) {
    if (container.dataset.bound) return;
    container.dataset.bound = 'true';
    const form = container.closest('form');
    const phone=container.querySelector('[name="attributes[WhatsApp Number]"]');
    const validatePhone=()=>{const normalized=normalizePhone(phone.value);phone.setCustomValidity(phone.value.trim() && !normalized ? words.phone_error : '');return normalized;};
    phone.addEventListener('input',validatePhone);
    phone.addEventListener('change',()=>{const normalized=validatePhone();if(normalized)phone.value=normalized;});
    validatePhone();
    const state = container.querySelector('[name="attributes[State]"]');
    const error = container.querySelector('[data-estimate-error]');
    let cart = JSON.parse(container.querySelector('[data-estimate-cart]').textContent);
    const draw = () => {
      const estimate = calculate(cart);
      const summary = container.querySelector('[data-estimate-summary]');
      const rows = [words.total + ': ' + money(estimate.total), words.weight + ': ' + estimate.kg.toFixed(2) + ' kg', words.no_gst];
      summary.replaceChildren(...rows.map(text=>{const p=document.createElement('p');p.textContent=text;return p;}));
    };
    container.addEventListener('change',draw);
    draw();
    let postalRequest = 0;
    container.querySelector('[name="attributes[Pincode]"]').addEventListener('change',async event=>{
      const pin=event.target.value,seq=++postalRequest,status=container.querySelector('[data-postal-status]');
      if (!/^[1-9][0-9]{5}$/.test(pin)) return;
      status.textContent=words.postal_loading;
      try {
        const response=await fetch(`https://api.postalpincode.in/pincode/${encodeURIComponent(pin)}`,{signal:AbortSignal.timeout(7000)});
        if(!response.ok) throw Error();
        const data=await response.json(),office=data?.[0]?.PostOffice?.[0];
        if(seq!==postalRequest) return;
        if(!office) throw Error();
        container.querySelector('[name="attributes[City]"]').value=office.District || office.Block || '';
        const normalized=String(office.State).toLowerCase().replace(/&/g,'and');
        const match=[...state.options].find(o=>o.value.toLowerCase()===normalized);
        state.value=match?.value || '';
        status.textContent=words.postal_check;draw();
      } catch { if(seq===postalRequest) status.textContent=words.postal_manual; }
    });
    let busy = false;
    form.addEventListener('submit',async event=>{
      if(!container.isConnected || event.defaultPrevented || event.submitter?.name !== 'aid_enquiry') return;
      event.preventDefault();
      const normalizedPhone=validatePhone();
      if(busy || !form.reportValidity()) return;
      phone.value=normalizedPhone;
      busy=true;error.textContent='';
      const button=event.submitter;button.disabled=true;
      try {
        cart=await getCart();window.aidValidateCart(cart);
        if(!cart.items?.length) throw Error(words.empty);
        const attributes=Object.fromEntries([...new FormData(form)].filter(([key])=>key.startsWith('attributes[')).map(([key,value])=>[key.slice(11,-1),String(value).trim()]));
        Object.assign(attributes,window.AlImranSalesmanReferral?.attributes() || {});
        const quote=calculate(cart);
        Object.assign(attributes,{'Shipping Mode':'','Booking Area':'','Delivery Type':'','Estimated Weight (kg)':quote.kg.toFixed(2),'Billable Weight (kg)':'','Estimated Shipping / Hamali':'','Estimated Total (INR)':String(quote.total/100),'Estimate Note':words.note});
        const response=await fetch(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
        const saved=await response.json();if(!response.ok) throw Error(saved.description||words.save_error);
        if(saved.attributes?.['WhatsApp Number']!==attributes['WhatsApp Number']) throw Error(words.save_error);
        const url=enquiryURL(saved,attributes);
        const confirmation=container.querySelector('[data-estimate-confirmation]');
        confirmation.querySelector('a').href=url;confirmation.hidden=false;
        button.disabled=false;busy=false;draw();
        window.location.assign(url);
      } catch(e) { error.textContent=e.message||words.save_error;button.disabled=false;busy=false;draw(); }
    });
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,async()=>{try{cart=await getCart();draw();}catch{error.textContent=words.save_error;}});
  }
  function bindWork(form) {
    if(form.dataset.bound) return;
    form.dataset.bound='true';
    const slots=[...form.querySelectorAll('[data-work-slot]')],error=form.querySelector('[data-work-error]');
    const initial=JSON.parse(form.querySelector('[data-work-cart]').textContent).items.filter(Boolean);
    const initialProperties=Array.isArray(initial[0]?.properties)?Object.fromEntries(initial[0].properties):initial[0]?.properties;
    if(initial.length===1 && initialProperties?.['_work_slots']) {
      try {const raw=initialProperties['_work_slots'].replace(/&quot;|&#34;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');const selected=JSON.parse(raw);slots.forEach(s=>{s.checked=s.dataset.workSlot in selected;const ref=form.querySelector(`[data-work-reference="${s.dataset.workSlot}"]`);if(ref)ref.value=selected[s.dataset.workSlot];});}catch{}
    }
    const draw=()=>{slots.forEach(s=>{const ref=form.querySelector(`[data-work-reference="${s.dataset.workSlot}"]`);if(ref){ref.disabled=!s.checked;ref.required=s.checked;}});const qty=slots.filter(s=>s.checked).length;form.querySelector('[data-work-summary]').textContent=qty+' '+words.pieces+' · '+money(qty*Number(form.dataset.price));};
    form.addEventListener('change',draw);draw();
    form.addEventListener('submit',async event=>{
      event.preventDefault();error.textContent='';
      if(!form.reportValidity())return;
      const selected=slots.filter(s=>s.checked),quantity=selected.length;
      if(!quantity){error.textContent=words.choose_piece;return;}
      const button=form.querySelector('[type=submit]');button.disabled=true;
      try {
        const cart=await getCart(),matching=cart.items.filter(i=>String(i.product_id)===form.dataset.productId);
        if(matching.length>1)throw Error(words.work_multiple);
        const references=Object.fromEntries(selected.map(s=>[s.dataset.workSlot,s.dataset.workSlot==='open'?'1':form.querySelector(`[data-work-reference="${s.dataset.workSlot}"]`).value.trim()]));
        const colours=Object.entries(references).filter(([key])=>key!=='open').map(([,value])=>value.toLowerCase());
        if(new Set(colours).size!==colours.length)throw Error(words.unique_colours);
        const properties={...(matching[0]?.properties||{}),'_work_slots':JSON.stringify(references),'Open Piece':references.open?'1':'0','Colour / Design References':selected.filter(s=>s.dataset.workSlot!=='open').map(s=>references[s.dataset.workSlot]).join(', ')};
        const cartUI=document.querySelector('cart-drawer'),sections=cartUI?.getSectionsToRender?.().map(s=>s.id)||['cart-icon-bubble'];
        const body=matching.length?{id:matching[0].key,quantity,properties,sections,sections_url:location.pathname}:{items:[{id:Number(form.dataset.variantId),quantity,properties}],sections,sections_url:location.pathname};
        const response=await fetch(`${root}cart/${matching.length?'change':'add'}.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
        const data=await response.json();if(!response.ok)throw Error(data.description||words.save_error);
        cartUI?.renderContents(data);
        if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'aid-work-picker',cartData:data});
      } catch(e){error.textContent=e.message||words.save_error;}finally{button.disabled=false;}
    });
  }
  const scan=scope=>{scope.querySelectorAll('[data-aid-estimate]').forEach(bindEstimate);scope.querySelectorAll('[data-aid-work-picker]').forEach(bindWork);};
  scan(document);
  new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(n=>{if(n.nodeType===1){if(n.matches('[data-aid-estimate]'))bindEstimate(n);if(n.matches('[data-aid-work-picker]'))bindWork(n);scan(n);}}))).observe(document.body,{childList:true,subtree:true});
})();


